/**
 * Pure filtering logic for the /documents page.
 * Extracted from the inline filterYourDocs closure in index.js for testability.
 */

/**
 * Filter a documents array by chip tags and a free-text search string.
 *
 * @param {Array}  documents    Source document array (not mutated)
 * @param {Array}  tagArray     Lowercase tag/type/year strings that must ALL match (AND logic)
 * @param {string} searchString Lowercase substring matched against name, tag, type, date, description
 * @returns {Array} Filtered array, or the original reference when no filters are active
 */
/**
 * Filter a documents array by year.
 * @param {Array}  documents  Source document array (not mutated)
 * @param {string} year       4-digit year string, or 'ALL' / falsy for no filter
 * @returns {Array}
 */
export function filterDocsByYear(documents, year) {
	if (!year || year === 'ALL') return documents;
	const y = Number(year);
	return documents.filter((d) => new Date(Date.parse(d.date)).getFullYear() === y);
}

export function filterDocuments(documents, tagArray, searchString) {
	if (!tagArray.length && !searchString.length) return documents;

	let result = documents;

	if (tagArray.length) {
		result = result.filter((d) => {
			const year = new Date(Date.parse(d.date)).getFullYear().toString();
			const docTags = [];
			if (d.tag) d.tag.split(',').forEach((t) => docTags.push(t.trim().toLowerCase()));
			if (d.type) docTags.push(d.type.toLowerCase());
			docTags.push(year);
			return tagArray.every((t) => docTags.includes(t));
		});
	}

	if (searchString.length) {
		const s = searchString.toLowerCase();
		result = result.filter(
			(d) =>
				(d.date && d.date.toLowerCase().includes(s)) ||
				(d.name && d.name.toLowerCase().includes(s)) ||
				(d.tag && d.tag.toLowerCase().includes(s)) ||
				(d.type && d.type.toLowerCase().includes(s)) ||
				(d.description && d.description.toLowerCase().includes(s))
		);
	}

	return result;
}
